import { render } from "./Kachel.vue?vue&type=template&id=8360ad4a&scoped=true"
import script from "./Kachel.vue?vue&type=script&lang=js"
export * from "./Kachel.vue?vue&type=script&lang=js"

import "./Kachel.vue?vue&type=style&index=0&id=8360ad4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8360ad4a"]])

export default __exports__